<rx-row class="header {{ headerClasses }}" *ngIf="!hideHeader">
  <h3>{{ data.payload.name ? data.payload.name : data.payload.title }}</h3>
  <div class="actions" *ngIf="!hideDialogClose">
    <rx-icon name="close" class="dark cp" (click)="close()"></rx-icon>
  </div>
</rx-row>
<mat-dialog-content class="mat-typography">
  <div class="body {{ bodyClasses }}">
    <!-- <div class="scrollable-container"> -->
    <!-- <div class="ps-show-always scroll-wrap"
                           #perfectScrollBar
                           [config]="{ suppressScrollY : true}"
                           [disabled]='disableScroll'
        > -->

    <ng-container #contentPlaceholder></ng-container>
    <!-- </div> -->
    <!-- </div> -->
  </div>
</mat-dialog-content>

<div
  class="flex flex-row aic footer {{ footerClasses }}"
  *ngIf="!hideFooter"
  matDialogActions
  [class.centered]="data.payload.buttons?.submit && data.payload.buttons?.custom"
>
  <!-- TODO: PDF Preview controls -->
  <rx-row *ngIf="pdf">
    <div>
      <rx-icon name="icon-circle-minus-2" class="dark mr10" (click)="switchSize(1)"></rx-icon>
      <rx-icon name="icon-circle-plus-2" class="dark" (click)="switchSize(0)"></rx-icon>
    </div>
    <rx-icon
      name="icon-arrow-left"
      class="dark"
      [ngClass]="{ activeIcon: pdf.page > 1 }"
      (click)="switchPage(0)"
    ></rx-icon>
    <span>{{ pdf.page }} / {{ pdf.pages }}</span>
    <rx-icon
      name="icon-arrow-right"
      class="dark"
      [ngClass]="{ activeIcon: pdf.page < pdf.pages }"
      (click)="switchPage(1)"
    ></rx-icon>
  </rx-row>
  <rx-button
    class="white"
    [id]="getId(data.payload.buttons?.deny?.text)"
    *ngIf="data.payload.buttons?.deny"
    (click)="denyClicked()"
  >
    {{ data.payload.buttons?.deny?.text }}
  </rx-button>

  <rx-button
    class="white"
    [id]="getId(data.payload.buttons?.dismiss?.text)"
    *ngIf="data.payload.buttons?.dismiss"
    (click)="dismissClicked()"
  >
    {{ data.payload.buttons?.dismiss?.text }}
  </rx-button>

  <rx-button
    class="white"
    [id]="getId(data.payload.buttons?.customSub?.text)"
    *ngIf="data.payload.buttons?.customSub"
    (click)="customSubClicked()"
  >
    {{ data.payload.buttons?.customSub?.text }}
  </rx-button>

  <rx-button
    class="blue"
    [id]="getId(data.payload.buttons?.submit?.text)"
    *ngIf="data.payload.buttons?.submit"
    (click)="submitClicked()"
    [disabled]="
      !isContentPlaceholderValid() ||
      isPasswordValid ||
      (!data?.payload?.skipDirtyCheck && contentComponentRef?.instance?.isFormDirty === false)
    "
    [class.invalid]="!isValid"
  >
    {{ data.payload.buttons?.submit?.text }}
  </rx-button>

  <rx-button
    class="blue"
    *ngIf="data.payload.buttons?.custom"
    (click)="customClicked(data.payload.buttons?.custom?.preventClose)"
  >
    {{ data.payload.buttons?.custom?.text }}
  </rx-button>

  <rx-button
    class="dismiss"
    [id]="getId(data.payload.buttons?.cancel?.text)"
    *ngIf="data.payload.buttons?.cancel"
    (click)="dismissClicked()"
  >
    {{ data.payload.buttons?.cancel?.text }}
  </rx-button>

  <rx-button
    class="danger"
    [id]="getId(data.payload.buttons?.danger?.text)"
    *ngIf="data.payload.buttons?.danger"
    (click)="dangerClicked()"
  >
    {{ data.payload.buttons?.danger?.text }}
  </rx-button>
</div>
